import { render } from "./RelateScheduleSpots.vue?vue&type=template&id=e4218df0"
import script from "./RelateScheduleSpots.vue?vue&type=script&lang=js"
export * from "./RelateScheduleSpots.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__